import { useEffect, useState } from "react";
import Header from "./Header";
import './Onboarding.css'
import { useDispatch, useSelector } from "react-redux";
import { selectAppAuth } from "../../services/auth/authSlice";
import { checkUserFields, selectUserInfo, updateUserData, updateUserField } from "../../features/User/userSlice";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";

import Lottie from 'lottie-react';

import Text from "../../components/Text";
import Button from "../../components/Button";
import Form from 'react-bootstrap/Form';
import Select from 'react-select'

import logo_tf from '../../assets/images/logo_blue.svg'
import s_0_intro from './images/step_0/bye.svg'
import preview_img from './images/step_0/preview.png'
import info_img from '../../assets/images/info.svg'
import error_img from '../../assets/images/error_icon.svg'

import s_0_0 from './images/step_0/users.svg'
import s_0_1 from './images/step_0/formazione.svg'
import s_0_2 from './images/step_0/verifica.svg'
import s_0_3 from './images/step_0/stats.svg'
import s_0_4 from './images/step_0/art.svg'

import img_1 from './images/step_3/timer-red.svg'
import img_2 from './images/step_3/logica.svg'
import img_3 from './images/step_3/art.svg'
import img_4 from './images/step_3/upgrade.svg'

import hourglassAnimation from '../../assets/images/hourglass.json'

import { selectAppPersonalizations } from "../../services/utils/appInfoSlice";
import { API_URL, BASE_URL, DEFAULT_FIELDS } from "../../config/constants";
import FloatingLabel from "react-bootstrap/esm/FloatingLabel";
import { Navigate, useNavigate } from "react-router-dom";
import { fetchCreateNewDemoTenant, fetchCreateNewLead, fetchGetBusinessArea } from "./DemoApi";

import { SelectOption } from "../../components/_form/CustomSelectOption";
import { CustomSelectValueContainer } from "../../components/_form/CustomSelectValueContainer";
import { toast } from "react-toastify";
import { SaveToLocalStorage } from "../../utils/utils";
import ReactGA from "react-ga4";


export default function DemoScreen(props) {

    const [currentStep, setCurrentStep] = useState(0)
    const [leadData, setLeadData] = useState({
        "firstname": "",
        "lastname": "",
        "email": "",
        "telephone_number": "",
        "company_business_area": "",
        "company_name": "",
        "company_role": "",
        "expected_user_quota": 0,
        "privacy_check": false
    })
    const [businessAreas, setBusinessAreas] = useState([])

    const userAuth = useSelector(selectAppAuth)
    const userInfo = useSelector(selectUserInfo)
    const t = useSelector(selectTranslations);
    const missingFields = useSelector(checkUserFields)

    const dispatch = useDispatch()

    let navigate = useNavigate()

    const [hasSeenPrivacy, setHasSeenPrivacy] = useState(false);
    const [validatedForm, setValidatedForm] = useState(false);

    const getCompletedFields = () => {
        let count = 0
        for (var key in leadData) {
            if (leadData[key]) {
                count++
            }
        }
        return count
    }

    const calculateProgress = () => {
        if(currentStep === 0)
            return 5
        if(currentStep === 1)
            return 15 + parseInt((getCompletedFields()*75)/Object.keys(leadData)?.length )
        if(currentStep === 2){
            return 95
        }
        if(currentStep === 3)
            return 100
    }

    const handleChangeLeadData = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        setLeadData({
            ...leadData,
            [name]: value
        })
        if(leadData.firstname && leadData.lastname && leadData.email)
            setValidatedForm(true)
    }

    const handleChangeBusinessArea = (e) => {
        setLeadData({
            ...leadData,
            company_business_area: e?.value || null
        })
    }

    const startLeadProcess = (step) => {
        ReactGA.event({
            category: "lead",
            action: "start_lead_signup",
            label: "Lead Signup Process Started", 
            transport: "xhr"
        });
        setCurrentStep(step)
    }

    const createRandomString = (length)  => {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    
    const handleSubmitLead = async (event) => {
        const form = event.currentTarget;
        setValidatedForm(true);
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            event.preventDefault();
            event.stopPropagation();

            const _leadData = structuredClone(leadData)
            if(
                !_leadData.firstname || !leadData.lastname ||
                !_leadData.email || !_leadData.telephone_number
            ) {
                toast.error(t.demo.errors.missing_lead_field)
                return;
            }
            ReactGA.event({
                category: "lead",
                action: "compleated_lead_form",
                label: "Lead Form Compleated", 
                transport: "xhr"
            });
            const response = await fetchCreateNewLead(_leadData)
            if(response.success){
                if(response.data.successfull_demo_login){
                    ReactGA.event({
                        category: "lead",
                        action: "compleated_lead_signup",
                        label: "Lead acquired", 
                        transport: "xhr"
                    });
                    setCurrentStep(2)
                    let _tenant = _leadData?.company_name ? _leadData?.company_name?.toLocaleLowerCase() : createRandomString(7)
                    _tenant = _tenant.replace(/[^a-zA-Z0-9]/g, '');
                    _tenant = `${_tenant}-${createRandomString(7)}`

                    const response_demo = await fetchCreateNewDemoTenant({
                        tenant: _tenant
                    }) 
                    if(response_demo.success){
                        SaveToLocalStorage('refresh_auth',true)
                        setLeadData({
                            ...leadData,
                            tenant_creation: true,
                            tenant_creation_url: `${window.location.origin}/${_tenant}/admin`
                        })
                        ReactGA.event({
                            category: "lead",
                            action: "tenant_lead_created",
                            label: "Tenant Lead created", 
                            transport: "xhr"
                        });
                    } else if (response.error === "lead has already created namespace") {
                        setLeadData({
                            ...leadData,
                            tenant_creation: false,
                            tenant_creation_error: response.error 
                        })
                    } else {
                        setLeadData({
                            ...leadData,
                            tenant_creation: false,
                            tenant_creation_error: response.error 
                        })
                        ReactGA.event({
                            category: "lead",
                            action: "tenant_lead_creation_error",
                            label: "Tenant Lead not created", 
                            transport: "xhr"
                        });
                    }
                    setTimeout(()=>{
                        setCurrentStep(3)
                    },4000)
                }
            } else {
                toast.error(response.error)
                ReactGA.event({
                    category: "lead",
                    action: "lead_creation_error",
                    label: "Lead not created", 
                    transport: "xhr"
                });
            }
            
        }
        
    };

    const loadAvailableBusinessArea = async () => {
        const response = await fetchGetBusinessArea()
        if(response.success){
            setBusinessAreas(response.data)
        } else {
            console.error(response)
        }
    }
    
    useEffect(()=>{
        if(userAuth !== null && userInfo && userInfo?.user_data !== null && userInfo?.user_fields !== null){
            if (!userInfo?.user_data?.legal_checks?.external_legal_check) {
                setCurrentStep(1)
            } else if (missingFields) {
                setCurrentStep(2)
            } else if (!missingFields && userInfo.is_saved) {
                setCurrentStep(3)
                setTimeout(()=>{navigate('/', {replace:true})}, 5000)
            } else if(userAuth.is_new_user ) {
                setCurrentStep(0)
            }
        }
        
    }, [userAuth, userInfo])

    useEffect(()=>{
        loadAvailableBusinessArea()
    },[])
    
    return(
        <>
            {!userAuth.auth_token ?
                <div id="demoScreen">
                    {
                        currentStep > 0 &&
                            <Header progress={calculateProgress()} />
                    }
                    {
                        currentStep === 0 ?
                            <div className="container d-flex pt-5 px-3">
                                <div className="w-100">
                                    <img src={logo_tf} className="text-center mx-auto d-block" />
                                    <div className="row w-100 mt-4 mt-lg-5 mb-5 pb-5 align-items-center">
                                        <div className="col-12 col-lg-6">
                                            <img src={s_0_intro} />
                                            <h1 style={{fontSize:'32px'}}>{t.demo.title}</h1>
                                            <p style={{fontSize:'24px'}}>{t.demo.text}</p>
                                            
                                            <p className="animate__animated animate__fadeIn animate__delay" style={{fontSize:'20px'}}><img src={s_0_0} className="me-2"/>{t.demo.step_0.s_0}</p>
                                            <p className="animate__animated animate__fadeIn animate__delay-1s" style={{fontSize:'20px'}}><img src={s_0_1} className="me-2"/>{t.demo.step_0.s_1}</p>
                                            <p className="animate__animated animate__fadeIn animate__delay-2s" style={{fontSize:'20px'}}><img src={s_0_2} className="me-2"/>{t.demo.step_0.s_2}</p>
                                            <p className="animate__animated animate__fadeIn animate__delay-3s" style={{fontSize:'20px'}}><img src={s_0_3} className="me-2"/>{t.demo.step_0.s_3}</p>
                                            <p className="animate__animated animate__fadeIn animate__delay-4s" style={{fontSize:'20px'}}><img src={s_0_4} className="me-2"/><span dangerouslySetInnerHTML={{__html:t.demo.step_0.s_4}} /></p>
                                            
                                            
                                            <div className="d-flex d-lg-none  mt-4 mb-5">
                                                <Button  type={'button'} onClick={()=>startLeadProcess(1)} >
                                                    {t.demo.start_the_demo}
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div style={{position:'relative', paddingTop:'45.86387434554974%', borderRadius:'24px', overflow:'hidden'}} className="w-100"> 
                                                <iframe
                                                    src="https://customer-1yv0msz4xbgoinoh.cloudflarestream.com/ff0422953a1335e8941e83abc629c5c0/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-1yv0msz4xbgoinoh.cloudflarestream.com%2Fff0422953a1335e8941e83abc629c5c0%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=false"
                                                    loading="lazy"
                                                    style={{border:'none', position:'absolute', top:'0', left:'0', height:'100%', width:'100%'}}
                                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                                                    allowFullScreen={true}
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom_controller d-none d-lg-block">
                                       <div className=" d-lg-flex justify-content-center mt-2 mb-2">
                                            <Button className="mx-auto" type={'button'} onClick={()=>startLeadProcess(1)} >
                                                {t.demo.start_the_demo}
                                            </Button>
                                        </div> 
                                    </div>
                                    
                                </div>
                            </div>
                        : ""
                    }
                    {
                        currentStep === 1 ? 
                            <div className="scrollable mt-3 mt-lg-5 mb-5 pb-5 fade-in-animation" style={{height:'65vh', overflow:'scroll'}}>
                                <div className="container col-12 col-lg-6">
                                    <h1 className="text-left text-lg-center">{t.demo.step_1.title}</h1>
                                    <p className="text-left text-lg-center">{t.demo.step_1.text}</p>
                                    <Form noValidate validated={validatedForm} onSubmit={handleSubmitLead} className="w-100 mt-4 ">
                                        <Form.Group controlId={'firstname'} className="mb-3">
                                            <FloatingLabel
                                                controlId={'name'}
                                                label={t.demo.step_1.fields.firstname}
                                                key={'name'}
                                            >
                                                <Form.Control required type={'text'} placeholder={'Mario'} name="firstname" value={leadData.firstname || ''} onChange={handleChangeLeadData}/>
                                                <Form.Control.Feedback type="invalid" >
                                                    <small className="text-danger"><img src={error_img} alt="" className="me-1" style={{verticalAlign:'middle'}} />{t.forms.invalid_input}</small>
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                            
                                        </Form.Group>
                                        <Form.Group controlId={'lastname'} className="mb-3">
                                            <FloatingLabel
                                                controlId={'lastname'}
                                                label={t.demo.step_1.fields.lastname}
                                                key={'lastname'}
                                            >
                                                <Form.Control required type={'text'} placeholder={'Rossi'} name="lastname" value={leadData.lastname || ''} onChange={handleChangeLeadData}/>
                                                <Form.Control.Feedback type="invalid" >
                                                    <small className="text-danger"><img src={error_img} alt="" className="me-1" style={{verticalAlign:'middle'}} />{t.forms.invalid_input}</small>
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                            
                                        </Form.Group>
                                        <Form.Group controlId={'email'} className="mb-3">
                                            <FloatingLabel
                                                controlId={'email'}
                                                label={'E-mail'}
                                                key={'email'}
                                            >
                                                <Form.Control required type={'email'} placeholder={'mario.rossi@mariorossi.com'} name="email" value={leadData.email || ''} onChange={handleChangeLeadData}/>
                                                <Form.Control.Feedback type="invalid" >
                                                    <small className="text-danger"><img src={error_img} alt="" className="me-1" style={{verticalAlign:'middle'}} />{t.forms.invalid_input}</small>
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </Form.Group>
                                        <Form.Group controlId={'phone'} className="mb-3">
                                            <FloatingLabel
                                                controlId={'phone'}
                                                label={t.demo.step_1.fields.phone}
                                                key={'phone'}
                                            >
                                                <Form.Control required type={'tel'} placeholder={'3334567890'} name="telephone_number" pattern="[0-9]+.*[0-9]+" value={leadData.telephone_number || ''}  onChange={handleChangeLeadData}/>
                                                <Form.Control.Feedback type="invalid" >
                                                    <small className="text-danger"><img src={error_img} alt="" className="me-1" style={{verticalAlign:'middle'}} />{t.forms.invalid_input}</small>
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </Form.Group>
                                        <Form.Group controlId={'company_name'} className="mb-3">
                                            <FloatingLabel
                                                controlId={'company_name'}
                                                label={t.demo.step_1.fields.company_name}
                                                key={'company_name'}
                                            >
                                                <Form.Control type={'text'} placeholder={'MarioRossi SRL'} name="company_name" value={leadData.company_name || ''} onChange={handleChangeLeadData}/>
                                            </FloatingLabel>
                                        </Form.Group>
                                        <Select
                                            options={businessAreas?.map((b)=>{return({ value: b.business_area, label: b.business_area })})}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            classNamePrefix="react-select"
                                            components={{
                                                Option: SelectOption,
                                                ValueContainer: CustomSelectValueContainer
                                            }}
                                            className="select-form-control mb-1"
                                            isClearable
                                            allowSelectAll={true}
                                            styles={{
                                                placeholder: (provided, state) => ({
                                                    ...provided,
                                                    position: "absolute",
                                                    top: state.hasValue  ? "-40%" : "-5%",
                                                    transition: "top 0.1s, font-size 0.1s",
                                                    color: state.hasValue ? "#181818" : "#181818",
                                                    fontSize: (state.hasValue || state.isFocused ) ? "13px" : "16px"
                                                } 
                                                )
                                            }}
                                            required={true}
                                            placeholder={<div>{t.demo.step_1.fields.business_area}</div>}
                                            value={leadData.company_business_area ? {label: leadData.company_business_area, value: leadData.company_business_area } : null}
                                            onChange={handleChangeBusinessArea}
                                            
                                        />
                                        <small className="mb-3"><img src={info_img} alt="" className="me-1" style={{maxWidth:'16px',verticalAlign:'middle'}} />{t.demo.step_1.business_area_details}</small>
                                        <Form.Group controlId={'company_role'} className="mt-2 mb-5">
                                            <FloatingLabel
                                                controlId={'company_role'}
                                                label={t.demo.step_1.fields.company_role}
                                                key={'company_role'}
                                            >
                                                <Form.Control  type={'text'} placeholder={t.demo.step_1.fields.company_role} name="company_role" value={leadData.company_role || ''} onChange={handleChangeLeadData}/>
                                            </FloatingLabel>
                                        </Form.Group>
                                    <div className="bottom_controller">
                                        <Form.Check type={'checkbox'} id={`internal_legal_check`} className="login_legal_check mb-3">
                                            <Form.Check.Input type={'checkbox'} checked={leadData.privacy_check} name="privacy_check" onChange={handleChangeLeadData} required/>
                                            <Form.Check.Label>
                                                {t.login.internal_legal_check_1}
                                                <a href={`/admin/static/legals/privacy-policy.pdf`} target={'_blank'}><u>{t.login.internal_legal_check_privacy}</u></a> e i&nbsp;
                                                <a href={`/admin/static/legals/termini-e-condizioni.pdf`} target={'_blank'}><u>{t.login.internal_legal_check_terms}</u></a>
                                                &nbsp;{t.login.internal_legal_check_2}
                                            </Form.Check.Label>
                                        </Form.Check>
                                        <Button className="mx-auto" type={'submit'} 
                                            disabled={
                                                !leadData.privacy_check || 
                                                !leadData.firstname || 
                                                !leadData.lastname || 
                                                !leadData.telephone_number || 
                                                !leadData.email ||
                                                !leadData.company_business_area
                                            }>
                                            {t.demo.start}
                                        </Button>
                                    </div>
                                    </Form>
                                </div>
                            </div>
                        : ""
                    }
                    
                    {
                        currentStep === 2 ?
                            <div className="d-flex flex-column align-items-center justify-content-between fade-in-animation">
                                <div className="d-flex flex-column text-center justify-content-center align-items-center mt-5   ">
                                    <Lottie
                                        animationData={hourglassAnimation}
                                        autoplay={true}
                                        loop={100000}
                                        style={{width:"100px"}}
                                        className="d-block me-2 mb-3" 
                                    />  
                                    <h1 className="text-center mt-2 loading_text">{t.demo.loading_title}</h1>
                                    <p className="text-center mt-3">{t.demo.loading_text}</p>
                                </div>
                            </div>
                        : ""
                    }
                    {
                        currentStep === 3 ?
                            <div className="step mt-4 fade-in-animation">
                                <img src={s_0_intro} className="d-block mx-0 mx-lg-auto"/>
                                {
                                    leadData?.tenant_creation ?
                                    <>
                                    <h1 className="text-start text-lg-center mt-2">{t.demo.step_3.title}</h1>
                                    <p className="mt-2 mb-0">{t.demo.step_3.text}:</p>
                                    <ul className="next_steps">
                                        <li>
                                            <img src={img_1} />
                                            <Text className="mb-0">{t.demo.step_3.demo_1}</Text>
                                        </li>
                                        <li>
                                            <img src={img_2} />
                                            <Text className="mb-0">{t.demo.step_3.demo_2}</Text>
                                        </li>
                                        <li>
                                            <img src={img_3} />
                                            <Text className="mb-0">{t.demo.step_3.demo_3}</Text>
                                        </li>
                                        <li>
                                            <img src={img_4} />
                                            <Text className="mb-0">{t.demo.step_3.demo_4}</Text>
                                        </li>
                                    </ul>
                                    <a href={leadData?.tenant_creation_url || "#"}>
                                        <Button className="mt-4" >
                                            {t.demo.step_3.cta}!
                                        </Button>
                                    </a>
                                    </> : <>
                                        <h1 className="text-start text-lg-center mt-4">{t.demo.errors.already_created_title}</h1>
                                        <p className="mt-3 mb-0 text-lg-center">{t.demo.errors.already_created_text}</p>
                                        <a href="mailto:leonardo.curini@thefacultyapp.com?subject=Demo thefaculty business">
                                            <Button className="mt-4" >
                                                {t.demo.modals.expired_cta}!
                                            </Button>
                                        </a>
                                    </>
                                }
                            </div>
                        : ""
                    }
                </div>
            : 
                <Navigate to={'/'} />
            }
        </>
    )
}